






























































































































































































































import { ResizeObserver } from "vue-resize";
import BaseAnimation from "@/app/shared/components/base/BaseAnimation.vue";

export default {
  name: "BaseVideoPackshotTimeline",
  components: {
    ResizeObserver,
    BaseAnimation,
  },
  data: function () {
    return {
      isDragLeft: false,
      isDragRight: false,
    };
  },
  computed: {
    relativeWidth: function () {
      return (
        ((this.value.finishTime - this.value.startTime) * 100) / this.duration
      );
    },
    leftPosition: function () {
      return (this.value.startTime * 100) / this.duration + "%";
    },
    isLoadingPackshot: function () {
      if (!this.$store.state.selectedItem.currentVariation.checked) {
        return this.$store.state.selectedItem.currentVariation
          .isLoadingPackshot;
      } else {
        return this.$store.state.items.some((i) => {
          return i.variations.some((v) => {
            return v.checked && v.isLoadingPackshot;
          });
        });
      }
    },
  },
  mounted() {
    this.onResize();
  },
  watch: {
    source: function () {
      this.$forceUpdate();
      this.onResize();
    },
  },
  props: {
    source: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      required: true,
    },
    speed: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    thumbs: {
      type: Array,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    packshot: {
      type: Object,
    },
    packshotThumbs: {
      type: Array,
      required: false,
    },
    packshotType: {
      type: String,
      required: true,
    },
    packshotDuration: {
      type: Number,
      required: true,
    },
  },
  methods: {
    onResize() {
      if (!this.thumbs) {
        let canvas = <HTMLCanvasElement>document.getElementById("canvas");
        canvas.width = this.$refs.snapshots
          ? this.$refs.snapshots.getBoundingClientRect().width
          : 0;
        this.updateCanvasBySource(canvas, 10, this.source, this.duration);
      }
      if (!this.packshotThumbs) {
        this.updatePackshotCanvas();
      }
    },
    updatePackshotCanvas() {
      if (this.packshot && this.packshotType === "video") {
        let canvas = <HTMLCanvasElement>(
          document.getElementById("canvasPackshot")
        );
        canvas.width = this.$refs.packshot
          ? this.$refs.packshot.getBoundingClientRect().width - 8
          : 0;
        if (canvas.width <= 65) {
          //костыль при смене кнопки на канвас
          return;
        }
        this.updateCanvasBySource(
          canvas,
          4,
          this.$baseURL + this.packshot.path,
          this.packshotDuration
        );
      }
    },
    updateCanvasBySource(canvas, count, src, duration) {
      let ctx = canvas.getContext("2d");
      let cw = canvas.width;
      let ch = canvas.height;

      let position = 0;

      let v = <HTMLVideoElement>document.createElement("video");
      v.muted = true;
      v.src = src;
      v.play();

      v.addEventListener(
        "loadedmetadata",
        async function () {
          let x, y;
          x = 0;
          y = 0;

          let seekResolve;
          v.addEventListener("seeked", async function () {
            if (seekResolve) seekResolve();
          });

          let frameWidth = cw / count;
          let range = duration / count;
          ctx.clearRect(x, y, cw, ch);
          for (let i = 0; i < count; i++) {
            v.currentTime = range * i;
            await new Promise((r) => (seekResolve = r));
            ctx.drawImage(v, x, y, frameWidth, ch);
            x += frameWidth;
          }
        },
        false
      );
    },
    addPackshot() {
      this.$emit("addPackshot");
    },
    trashPackshot() {
      this.$emit("trashPackshot");
    },
    openEndCardLibraryWindow() {
      this.$store.commit("showEndCardLibraryWindow", true);
    },
    getVideoPercentDuration() {
      return (
        (this.duration /
          this.speed /
          (this.duration / this.speed +
            (this.packshot ? this.packshotDuration : 0))) *
        100
      );
    },
    getPackshotPercentDuration() {
      return (
        ((this.packshot ? this.packshotDuration : 0) /
          (this.duration / this.speed +
            (this.packshot ? this.packshotDuration : 0))) *
        100
      );
    },
  },
};
